
import { cardGlider } from './cardGlider';

export const offerGlider = () => {

    const selectors = {
        root: '[data-component="glider"]'
    };

    const responsiveConfig =  [
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 'auto',
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 'auto',
          slidesToScroll: 'auto',
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          itemWidth: 150,
          dots: '',
          draggable: false,
        }
      }];

    const init = () => {
      let cardModule = new cardGlider();
      cardModule.init(selectors.root, responsiveConfig);
    };

    return {
        init: init
    };
}